import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";


export type PropertyItem = {
    propertyName: string,
    propertyValue: string
}

interface CustomerDataProps {
    data: PropertyItem[],
}

export const CustomerData = (props: CustomerDataProps) => {
    return (
        <>
            <Title>Dane klienta</Title>
            <Wraper>
                {props.data.map((property) => (
                    <ItemInfoWraper key={property.propertyName}>
                        <FieldName>{property.propertyName}:</FieldName>
                        <FieldValue>{property.propertyValue}</FieldValue>
                    </ItemInfoWraper>
                ))}
            </Wraper>
        </>
    );
};

const Wraper = styled.div`
display:flex;
flex-direction:column;
margin-bottom: 48px;



`;
const Title = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 16px;
line-height: 24px;
color: ${theme.colors.black_primaryText};
padding-bottom:23px;
`;
const ItemInfoWraper = styled.div`

`;
const FieldName = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 12px;
line-height: 18px;
color: ${theme.colors.gray01_secondaryText};
`;
const FieldValue = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.black_primaryText};
padding-bottom:12px;
overflow-wrap: break-word;
`;